//Modified by : Y0lk, 2013-03-20
//--Added a "data" setting to send custom post data with the file
(function ($) {
    $.fn.html5Uploader = function (options) {
        var me = this;
        var crlf = '\r\n';
        var boundary = "iloveigloo";
        var dashes = "--";
        
        me.settings = {
            "name": "uploadedFile",
            "postUrl": "Upload.aspx",
            "data": {},
            "fileCheck": null,
            "onClientAbort": null,
            "onClientError": null,
            "onClientLoad": null,
            "onClientLoadEnd": null,
            "onClientLoadStart": null,
            "onClientProgress": null,
            "onServerAbort": null,
            "onServerError": null,
            "onServerLoad": null,
            "onServerLoadStart": null,
            "onServerProgress": null,
            "onServerReadyStateChange": null,
            "onSuccess": null
        };

        if (options) {
            $.extend(me.settings, options);
        }

        return this.each(function (options) {
            var $this = $(this);
            if ($this.is("[type=\"file\"]")) {
                if (this.files.length > 0){
                    var files = this.files;
                    for (var i = 0; i < files.length; i++) {
                        //Call handler after file check
                        if(me.settings.fileCheck)
                            me.settings.fileCheck(files[i], fileHandler);
                        else
                            fileHandler(files[i]);
                    }
                }else{
                    $this.bind("change", function () {
                        var files = this.files;
                        for (var i = 0; i < files.length; i++) {
                             //Call handler after file check
                            if(me.settings.fileCheck)
                                me.settings.fileCheck(files[i], fileHandler);
                            else
                                fileHandler(files[i]);
                        }
                    });
                }
            } else {
                $this.bind("dragenter dragover", function () {
                    return false;
                }).bind("drop", function (e) {
                    var files = e.originalEvent.dataTransfer.files;
                    for (var i = 0; i < files.length; i++) {
                         //Call handler after file check
                        if(me.settings.fileCheck)
                            me.settings.fileCheck(files[i], fileHandler);
                        else
                            fileHandler(files[i]);
                    }
                    return false;
                });
            }
            this.uploader = me;
        });

        function fileHandler(file) {
            var fileReader = new FileReader();

            if(me.settings.onFileSelected)
                me.settings.onFileSelected(file);

            fileReader.onabort = function (e) {
                if (me.settings.onClientAbort) {
                    me.settings.onClientAbort(e, file, fileReader);
                }
            };
            fileReader.onerror = function (e) {
                if (me.settings.onClientError) {
                    me.settings.onClientError(e, file, fileReader);
                }
            };
            fileReader.onload = function (e) {
                if (me.settings.onClientLoad) {
                    me.settings.onClientLoad(e, file, fileReader);
                }
            };
            fileReader.onloadend = function (e) {
                if (me.settings.onClientLoadEnd) {
                    me.settings.onClientLoadEnd(e, file, fileReader);
                }
            };
            fileReader.onloadstart = function (e) {
                if (me.settings.onClientLoadStart) {
                    me.settings.onClientLoadStart(e, file, fileReader);
                }
            };
            fileReader.onprogress = function (e) {
                if (me.settings.onClientProgress) {
                    me.settings.onClientProgress(e, file, fileReader);
                }
            };
            fileReader.readAsDataURL(file);

            var xmlHttpRequest = new XMLHttpRequest();
            xmlHttpRequest.upload.onabort = function (e) {
                if (me.settings.onServerAbort) {
                    me.settings.onServerAbort(e, file);
                }
            };
            xmlHttpRequest.upload.onerror = function (e) {
                if (me.settings.onServerError) {
                    me.settings.onServerError(e, file);
                }
            };
            xmlHttpRequest.upload.onload = function (e) {
                if (me.settings.onServerLoad) {
                    me.settings.onServerLoad(e, file);
                }
            };
            xmlHttpRequest.upload.onloadstart = function (e) {
                if (me.settings.onServerLoadStart) {
                    me.settings.onServerLoadStart(e, file);
                }
            };
            xmlHttpRequest.upload.onprogress = function (e) {
                if (me.settings.onServerProgress) {
                    me.settings.onServerProgress(e, file);
                }
            };
            xmlHttpRequest.onreadystatechange = function (e) {
                if (me.settings.onServerReadyStateChange) {
                    me.settings.onServerReadyStateChange(e, file, xmlHttpRequest.readyState);
                }
                if (me.settings.onSuccess && xmlHttpRequest.readyState == 4 && xmlHttpRequest.status == 200) {
                    me.settings.onSuccess(e, file, xmlHttpRequest.responseText);
                }
            };
            xmlHttpRequest.open("POST", me.settings.postUrl, true);

            if (window.FormData) {
                var formData = new FormData();
                formData.append(me.settings.name, file);

                //Add post data to the request
                for(key in me.settings.data) {
                    formData.append(key, me.settings.data[key]);
                }

                xmlHttpRequest.send(formData);
            }
        }
    };
})(jQuery);